import { makeStyles } from 'tss-react/mui';
export const minHeights = {
    SMALL: { xs: 335, sm: 300, md: 300, lg: 300, xl: 300 },
    MEDIUM: { xs: 335, sm: 300, md: 436, lg: 512, xl: 512 },
    LARGE: { xs: 335, sm: 320, md: 476, lg: 600, xl: 824 },
    BLOG: { xs: 376, sm: 400, md: 500, lg: 500, xl: 512 },
};
export const generateHeadingStyles = (theme, spacing, colors) => (Object.assign(Object.assign(Object.assign({ display: 'flex', flexDirection: 'column' }, theme.typography.xl_regular), theme.typographySpacing.none), { color: colors.supplementary.white, [theme.breakpoints.up('sm')]: {
        marginBottom: spacing.small,
    }, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl), { marginBottom: spacing.small }), [theme.breakpoints.up('lg')]: {
        marginBottom: spacing.medium,
    }, [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxxxl), { marginBottom: spacing.large }) }));
const useStyles = makeStyles()((theme, _params, classes) => ({
    minHeightSmall: {
        [`&, & .${classes.image}`]: {
            minHeight: minHeights.SMALL.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.SMALL.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.SMALL.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.SMALL.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.SMALL.xl,
            },
        },
        '&, & video': {
            minHeight: '212px',
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.SMALL.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.SMALL.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.SMALL.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.SMALL.xl,
            },
        },
    },
    minHeightMedium: {
        [`&, & .${classes.image}`]: {
            minHeight: minHeights.MEDIUM.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.MEDIUM.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.MEDIUM.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.MEDIUM.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.MEDIUM.xl,
            },
        },
    },
    // Based on Home Hero Banner - m-promo_fullwidth_large
    minHeightLarge: {
        [`&, & .${classes.image}`]: {
            minHeight: minHeights.LARGE.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.LARGE.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.LARGE.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.LARGE.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.LARGE.xl,
            },
        },
        [`& .${classes.videoContainer}`]: {
            minHeight: minHeights.SMALL.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.LARGE.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.LARGE.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.LARGE.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.LARGE.xl,
            },
        },
    },
    // Based on Home Hero Banner - m-promo_fullwidth_large
    minHeightBlog: {
        [`&, & .${classes.image}`]: {
            minHeight: minHeights.BLOG.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.BLOG.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.BLOG.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.BLOG.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.BLOG.xl,
            },
        },
    },
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
            [`& .${classes.image}.${classes.ffImage} img`]: {
                objectPosition: 'bottom right',
            },
        },
    },
    image: {},
    ffImage: {},
    videoContainer: {},
}));
export default useStyles;
